import Error404 from "../../assets/images/errors/error404.png";
import Navbar from "../../components/navigation/Navbar";
const PageNotFound = () => {
  return (
    <div className="bg-bkg pt-6 px-10">
      <Navbar />
      <div className="flex flex-col text-text-1 items-center justify-center h-auto bg-bkg p-4">
        <img
          src={Error404}
          alt="Not Authorized"
          className="w-64 h-64 md:w-80 md:h-80 mb-8 object-cover"
        />
        <h3 className="font-semibold text-text-1/80 mb-4">
          The page you are looking for cannot be found.
        </h3>
        {/* <p className="text-text-1/60 text-center max-w-md">
        Please contact your administrator if you believe this is an error,
      </p> */}
      </div>
    </div>
  );
};

export default PageNotFound;
